module.exports = __webpack_public_path__ + "assets/img/help_tenBtn.1b8506c6.png";